import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Delete } from '@mui/icons-material';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { Alert } from '@mui/material';
import { useConfirmDialog } from 'console/shared/hooks/ui';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { removeSim } from 'console/sim/redux/actions';
import { useNavigateTo } from 'shared/hooks/router';
import { LoadingButton } from '@mui/lab';
export function SimRemoveButton(props) {
    const { msisdn, sim_type, iccid, sim_in_device } = props;
    const { loading, error } = useAppSelector((state) => state.sim_dialogs.remove_info);
    const onRemoveSim = useAction(removeSim);
    const onBackDialog = useNavigateTo('/sim/list');
    const handlerRemove = useCallback(() => {
        if (msisdn != null && sim_type != null) {
            onRemoveSim(sim_type, msisdn, iccid, sim_in_device);
            onBackDialog();
        }
    }, [msisdn, sim_type, onRemoveSim, onBackDialog, iccid, sim_in_device]);
    const [ConfirmDialog, openConfirmDialog] = useConfirmDialog();
    // +79875318451
    return (_jsxs(ErrorBoundary, { children: [_jsx(LoadingButton, { color: "error", onClick: openConfirmDialog, variant: "outlined", startIcon: _jsx(Delete, {}), loading: loading, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0438\u043C-\u043A\u0430\u0440\u0442\u0443" }), error && _jsx(Alert, { severity: "error", children: error }), _jsx(ConfirmDialog, { onConfirm: handlerRemove, children: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C c\u0438\u043C-\u043A\u0430\u0440\u0442\u0443?" })] }));
}
